





















import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import { DeviceDetectorService } from '../../services/device-detector.service';

@Component
export default class OpenSchedulingDialog extends Vue {
  @Prop({ type: Boolean, required: true, default: false })
  readonly value!: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  readonly disabled!: boolean;

  @Prop({ type: String, required: true, default: '' })
  readonly source!: string;

  @Inject('$device')
  private $device!: DeviceDetectorService;

  get show() {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit('input', value);
  }

  get isMobile() {
    return this.$device.mobile;
  }

  close() {
    this.show = false;
  }

}
